export default __webpack_public_path__ + "locales/sq-AL/Article.json?hash=14a7874d4dc64ed21b6696ff6c9962bf";